




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { DropDownItem } from './types/dropdownItem';

@Component
export default class AppDropdownItem extends Vue {
  @Prop({ required: true, type: Object }) readonly dropDownItem: DropDownItem<number>;

  name = 'AppDropdownItem';

  onSelectDropdownItem(item: DropDownItem<number>, event: Event): void {
    if (!item.disabled) {
      this.$emit('on-select-dropdown-item', item);
    }
  }
}
